<template>
  <div class="categoryName">
    价格指数
  </div>
</template>
<script>
export default{
  props:['categoryName']
}
</script>
<style lang="scss">
</style>




// WEBPACK FOOTER //
// src/components/categoryName/priceIndices.vue